import { createAction } from '@ngrx/store';

export const logoutAction = createAction('[Auth] Logout');
